import { formatUnixTime, formatUtcString } from '@/utils/date-format'
import { App } from 'vue'

export function registerProperties(app: App) {
  app.config.globalProperties.$filters = {
    formatTime(value: string) {
      return formatUtcString(value)
    },
    formatUnixTime(value: number) {
      return formatUnixTime(value)
    }
  }
}
